/** The statement under the hero, with its avatars and activity cards. */

export const STATEMENT = {
  // `muted` parts render in the lighter grey; `mark` parts fill with blue as
  // the section scrolls in.
  headline: [
    { text: 'Create your organization in ', muted: true },
    { text: 'minutes,', muted: true, mark: true },
    { text: ' invite your team, ', muted: true },
    { text: 'and every room booking, visitor and approval lands in ' },
    { text: 'one shared schedule.', mark: true },
  ],
  avatars: [
    { initials: 'SH', tone: 'blue' },
    { initials: 'OF', tone: 'teal' },
    { initials: 'NA', tone: 'orange' },
  ],
  text: 'Each role gets its own panel and sign-in: your team books rooms and meetings, reception signs visitors in and out, HR approves members and bookings, and admins run rooms, seats and settings.',
  // Activity cards that slide in beside the text.
  pills: [
    {
      icon: 'building',
      tone: 'blue',
      title: 'Organization created',
      meta: 'Cloudgate · 2 min ago',
    },
    {
      icon: 'calendar',
      tone: 'teal',
      title: 'Room booked',
      meta: 'Atlas · Thu 10:00 AM',
    },
    {
      icon: 'check',
      tone: 'orange',
      title: 'Booking approved',
      meta: 'by HR · just now',
    },
  ],
}
